import request from '@/utils/request';

// eslint-disable-next-line import/prefer-default-export
export function getInfo(token) {
  return request({
    url: '/user_info',
    method: 'get',
    params: { token },
  });
}
